import GlassCard from '../ui/glass/components/GlassCard';

import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { Box, Typography, FormControlLabel, Switch, Button, CircularProgress, Alert } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PageHeader from '../components/common/PageHeader';
import { Loading } from '../components/common/Loading';

const YapayZekaAyarlari = () => {
    const [settings, setSettings] = useState({ enabled: false });
    const [loading, setLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        const docRef = doc(db, 'settings', 'aiAssistant');
        const unsubscribe = onSnapshot(docRef, (docSnap) => {
            if (docSnap.exists()) {
                setSettings(docSnap.data());
            } else {
                // Varsayılan ayar
                setSettings({ enabled: false });
            }
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    const handleToggleChange = (event) => {
        setSettings(prev => ({ ...prev, enabled: event.target.checked }));
    };

    const handleSave = async () => {
        setIsSaving(true);
        try {
            await setDoc(doc(db, 'settings', 'aiAssistant'), settings);
            alert('Ayarlar kaydedildi.');
        } catch (error) {
            console.error("Yapay zeka ayarları kaydedilirken hata:", error);
            alert('Bir hata oluştu.');
        } finally {
            setIsSaving(false);
        }
    };

    if (loading) {
        return <Loading message="Ayarlar yükleniyor..." />;
    }

    return (
        <Box sx={{ p: { xs: 1, md: 1 } }}>
            <PageHeader
                title="Yapay Zeka Asistanı"
                subtitle="Sesli asistan ayarlarını buradan yapılandırabilirsiniz."
                icon={<SmartToyIcon />}
            />

            <GlassCard sx={{ p: 3, maxWidth: 600 }}>
                <Typography variant="h6" gutterBottom>
                    Asistan Kontrolü
                </Typography>
                <Alert severity="info" sx={{ mb: 2 }}>
                    Yapay Zeka Sesli Asistanı, komutlarınızı işlemek için Google Cloud AI servislerini kullanır ve ek maliyetlere neden olabilir.
                </Alert>
                <FormControlLabel
                    control={<Switch checked={settings.enabled} onChange={handleToggleChange} />}
                    label="Sesli Asistanı Etkinleştir"
                />
                <Typography variant="body2" color="text.secondary">
                    Bu ayar aktif edildiğinde, ekranın alt orta kısmında asistan butonu görünecektir.
                </Typography>
                <Box sx={{ mt: 3, textAlign: 'right' }}>
                    <Button variant="contained" onClick={handleSave} disabled={isSaving}>
                        {isSaving ? <CircularProgress size={24} /> : 'Ayarları Kaydet'}
                    </Button>
                </Box>
            </GlassCard>
        </Box>
    );
};

export default YapayZekaAyarlari;